import { useState } from 'react';
import styled from 'styled-components';

import PrivateLayout from '../../../layout/PrivateLayout';
import { Container } from './../../../styles/Common';
import AdminNavbar from './../../../components/Admin/AdminNavbar/index';
import Quotes from './Quotes';
import Pagination from '../../../components/Admin/Pagenation';
import { useParams } from 'react-router-dom';

const MarkedAsUnreadQuotesPage = () => {
  const limit: number = 10;

  const { page } = useParams();

  const [count, setCount] = useState<number>(0);

  return (
    <>
      <PrivateLayout>
        <title>Dashboard | Ripify</title>
        <PageWrapper>
          <AdminNavbar />
          <Container>
            <Wrapper>
              <PageTitle>Marked As Unread Quotes</PageTitle>
              <TableHead>
                <ThDate>Date</ThDate>
                <ThCompanyName>Company Name</ThCompanyName>
                <ThEmail>Email</ThEmail>
                <ThAction>Action</ThAction>
              </TableHead>
              <Quotes setCount={setCount} limit={limit} />
            </Wrapper>
            {count > limit && (
              <>
                <Pagination
                  rootUrl={'/admin/dashboard/quotes/marked-as-unread/page'}
                  totalPage={Math.ceil(count / limit)}
                  currentPage={Number(page)}
                />
              </>
            )}
          </Container>
        </PageWrapper>
      </PrivateLayout>
    </>
  );
};

export default MarkedAsUnreadQuotesPage;

const PageWrapper = styled.div`
  padding-bottom: 400px;
`;

const Wrapper = styled.div`
  margin-bottom: 50px;
`;

const PageTitle = styled.h2`
  text-align: center;
  font-size: 24px;
  margin-bottom: 30px;
  color: #5da6ed;
`;

// date,name,email,action(view)
const TableHead = styled.div`
  width: 100%;
  display: flex;
  font-size: 25px;
  font-weight: 600;
  font-family: font-semibold;
  background-color: rgba(93, 165, 237, 0.1);
  color: #5da6ed;

  @media (max-width: 576px) {
    display: none;
  }
`;

const ThDate = styled.div`
  padding: 10px 5px;
  width: 15%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 1px solid rgba(0, 0, 0, 0.1);
`;
const ThCompanyName = styled.div`
  padding: 5px;
  width: 35%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 1px solid rgba(0, 0, 0, 0.1);
`;
const ThEmail = styled.div`
  padding: 5px;
  width: 35%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 1px solid rgba(0, 0, 0, 0.1);
`;
const ThAction = styled.div`
  padding: 5px;
  width: 15%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
